// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GRsv61K-PUdj2gIVRNGhbg\\=\\={color:#4c70ef;font:inherit;text-decoration:underline}.q\\+NFkkbkWPFuHAEyXGrWBw\\=\\={color:#22a276}", "",{"version":3,"sources":["webpack://./resources/js/v2/components/MerchantNameLink/MerchantNameLink.module.scss"],"names":[],"mappings":"AAAA,4BACE,aAAA,CAEA,YAAA,CADA,yBAEF,CAEA,6BACE,aACF","sourcesContent":[".link {\n  color: #4c70ef;\n  text-decoration: underline;\n  font: inherit;\n}\n\n.link_kurv {\n  color: #22a276;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "GRsv61K-PUdj2gIVRNGhbg==",
	"link_kurv": "q+NFkkbkWPFuHAEyXGrWBw=="
};
export default ___CSS_LOADER_EXPORT___;
